import type { TrackerMessage, TrackerMessageOverview } from '@racemap/sdk/schema/trackers';
import {
  getCurrentMessageStatusCode,
  isMessageNotAcknowledgeEventIfItCouldBe,
  isMessageNotAcknowledged,
  isMessageNotSent,
} from '@racemap/utilities/functions/messages';
import type { Immutable } from 'immer';

export const getMessageState = (
  message: Immutable<TrackerMessageOverview | TrackerMessage>,
): string => {
  if (isMessageNotSent(message)) {
    return 'NOT_SENT';
  }
  if (isMessageNotAcknowledgeEventIfItCouldBe(message)) {
    return 'NOT_ACKNOWLEDGED';
  }
  if (isMessageNotAcknowledged(message)) {
    return 'SENT';
  }
  if ((message.historyRecords?.length ?? 0) > 0) {
    return getCurrentMessageStatusCode(message);
  }
  if (message.plannedAt != null) {
    if (message.plannedAt.valueOf() < Date.now()) {
      return 'REQUESTED';
    }
    if (message.plannedAt.valueOf() > Date.now()) {
      return 'SCHEDULED';
    }
  }
  return 'UNKNOWN';
};
